/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITileListItemViewProps } from '@msdyn365-commerce-modules/tile-list';

import { ITileListItemProps } from '../definition-extensions/tile-list-item.ext.props.autogenerated';

/**
 *
 * ITileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
const renderTileListItemContent = (props: ITileListItemViewProps & ITileListItemProps<{}>): JSX.Element => {
    const {
        heading,
        paragraph,
        backgroundImage,
        links,
        thumbnailImage,
        tileListContainer,
        tileListImageContainer,
        tileListThumbnailImageContainer,
        tileListHeadingContainer
    } = props;

    function _renderDropdownLinks(): JSX.Element {
        if (props.config.enableDropdown) {
            return (
                <div className='dropdown-content'>
                    <div className='dropdown-title'>
                        <b>{props.config.dropdownTitle}</b>
                    </div>
                    <div className='dropdown-links'>{links}</div>
                </div>
            );
        }

        return <></>;
    }

    return (
        <>
            <Node {...tileListContainer}>
                <Node {...tileListImageContainer}>{backgroundImage}</Node>
                {_renderDropdownLinks()}
                <Node {...tileListHeadingContainer}>{paragraph}</Node>
                <Node {...tileListThumbnailImageContainer}>{thumbnailImage}</Node>
            </Node>
            {heading}
        </>
    );
};

/**
 *
 * TileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
export const TileListItemViewComponent: React.FC<ITileListItemViewProps & ITileListItemProps<{}>> = props => {
    const { tileListItem } = props;
    return <Module {...tileListItem}>{renderTileListItemContent(props)}</Module>;
};

export default TileListItemViewComponent;
